import { useState, useEffect } from 'react';

const logoUrl = new URL('../assets/ichi-logo.jpg', import.meta.url).toString();

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  const navLinks = [
    { label: 'About',    id: 'about' },
    { label: 'Services', id: 'services' },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''} ${menuOpen ? 'navbar--open' : ''}`}>
        <div className="navbar__logo" onClick={() => scrollTo('hero')}>
          <img src={logoUrl} alt="ICAI Logo" className="navbar__icai-logo" />
          <div className="navbar__logo-text">
            <span className="navbar__logo-name">Prabhu Mallya &amp; Associates</span>
            <span className="navbar__logo-sub">Chartered Accountants</span>
          </div>
        </div>

        <div className="navbar__links">
          {navLinks.map(({ label, id }) => (
            <button key={id} className="navbar__link" onClick={() => scrollTo(id)}>{label}</button>
          ))}
          <button className="navbar__cta" onClick={() => scrollTo('contact')}>Contact Us</button>
        </div>

        <button
          className={`navbar__hamburger ${menuOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div
        className={`mobile-menu ${menuOpen ? 'mobile-menu--open' : ''}`}
        aria-hidden={!menuOpen}
        {...(!menuOpen && { inert: true })}
      >
        <div className="mobile-menu__inner">
          <p className="mobile-menu__eyebrow">Navigation</p>
          <nav className="mobile-menu__links">
            {navLinks.map(({ label, id }) => (
              <button key={id} className="mobile-menu__link" onClick={() => scrollTo(id)}>
                {label}
              </button>
            ))}
          </nav>
          <button className="btn btn--primary btn--full" onClick={() => scrollTo('contact')}>
            Contact Us
          </button>
          <div className="mobile-menu__footer">
            <p>Prabhu Mallya &amp; Associates</p>
            <p>Chartered Accountants</p>
          </div>
        </div>
      </div>

      {menuOpen && <div className="mobile-menu__backdrop" onClick={() => setMenuOpen(false)} />}
    </>
  );
}
